module.exports = __webpack_public_path__ + "img/coordinates.c809fb23.png";